<div class="element-wrapper" [ngStyle]="wrapperStyles">
  @if (labelEnabled) {
    <blaze-element-header
      [color]="props?.style?.general?.title?.color1"
      [fontFamily]="props?.style?.titleBlock?.fontFamily"
      [fontSize]="props?.style?.titleBlock?.fontSize"
      [fontStyle]="props?.style?.titleBlock?.fontStyle"
      [fontWeight]="props?.style?.titleBlock?.fontWeight"
      [horizontalAlign]="props?.content?.title?.align"
      [icon]="props?.content?.title?.icon"
      [iconColor]="props?.content?.title?.iconColor?.color1"
      [iconPosition]="props?.content?.title?.iconPosition"
      [iconSize]="props?.style?.titleBlock?.iconSize"
      [ngStyle]="headerStyles"
      class="mb-16"
    >
      {{ labelText }}
    </blaze-element-header>
  }
  @if (isSourceBound) {
    @let isWrapping = isWrapping$ | async;
    <section
      class="list-rows flex flex-col gap-16"
      [class.isWrapping]="isWrapping"
      [class.isDetailsList]="isDetailsList"
    >
      @for (
        item of value$ | async;
        let idx = $index;
        track rowIdColumn ? item.row[rowIdColumn] : $index
      ) {
        @let ctx =
          {
            hasHeaders: (idx === 0 || isWrapping || isDetailsList) && showNamesAsHeaders,
            rowIndex: item.dataIdx,
            rowId: rowIdColumn ? item.row[rowIdColumn] : undefined,
          };
        <div class="flex items-center">
          @if (numberEntries) {
            <div
              class="font-medium w-32 mr-4 text-center self-start shrink-0"
              [class.pt-16]="!isDetailsList"
              [class.padded]="ctx.hasHeaders && !isDetailsList"
              [class.padded-sm]="isDetailsList"
            >
              {{ idx + 1 }}
            </div>
          }

          <div
            [blazeSlotNode]="slots?.slotNodesData?.['0']"
            [blazeSlotNodeRowContext]="ctx"
            class="form-list-row flex-grow min-w-0"
          >
            <ng-container
              *ngTemplateOutlet="
                slots?.templates?.['0'] || null;
                context: {
                  elementContext: {
                    rowContext: ctx,
                    showTitle: showNamesAsHeaders && (idx === 0 || isWrapping || isDetailsList),
                    forceExpandElements: shouldForceExpand,
                    dataContainer: 'form-list',
                  },
                }
              "
            />
          </div>
          @if (showDeleteAction) {
            <button
              class="flex items-center self-start border-a-12 rounded p-4 mt-[11px] bg-base-white hover:bg-base-light ml-12"
              [class.padded]="ctx.hasHeaders"
              (click)="deleteRow($event, item)"
            >
              <mat-icon svgIcon="icon_trash_16" />
            </button>
          }
        </div>
      }
    </section>
    <div class="flex">
      @if (showAddAction() && rowCountBelowLimit) {
        <button
          class="btn-add bd-btn add-item-button"
          [style.marginLeft]="numberEntries ? '36px' : '0'"
          data-cy="FormList:AddRow"
          [style.color]="generalTitleColor"
          [disabled]="isFetchingNewId()"
          (click)="addItem($event)"
        >
          <mat-icon svgIcon="icon_add_8" [style.background]="generalAccentColor" />
          {{ addNewLabel }}
        </button>
      }
    </div>
    <div class="flex">
      @if (hasValidationError) {
        <div
          class="validation basis-1/2 {{ numberEntries ? 'pl-40' : 'pl-4' }}"
          data-cy="FormList:validation"
        >
          {{ errorLabel }}
        </div>
      }
      @if (!isDetailsList) {
        <div
          [blazeSlotNode]="slots?.slotNodesData?.['actions']"
          class="flex-grow"
          data-cy="FormList:actions"
        >
          <ng-container *ngTemplateOutlet="slots?.templates?.['actions'] || null" />
        </div>
      }
    </div>
  } @else {
    <div class="hint-generate">
      <span class="description">
        To generate a form, choose your source data in the properties panel.
      </span>
      <button class="bd-btn border-a-12 mt-16">OPEN FORM LIST PROPERTY PANEL</button>
    </div>
  }
</div>
